import { render } from "./settings_custom_code.vue?vue&type=template&id=645e09ba&scoped=true"
import script from "./settings_custom_code.vue?vue&type=script&lang=js"
export * from "./settings_custom_code.vue?vue&type=script&lang=js"

import "./settings_custom_code.vue?vue&type=style&index=0&id=645e09ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645e09ba"]])

export default __exports__